import React, { useEffect } from 'react';

import { LoadingOverlay } from '@occc-app/design-system';

import { SomethingWrong } from './AppContext/components/SomethingWrong';

import { useInitSession } from '../Auth/useInitSession';

type AppInitializerProps = {
  children: React.ReactNode;
};

export const AppInitializer = ({ children }: AppInitializerProps) => {
  const { initializeSession, isLoading, isInitialized, error } = useInitSession();

  useEffect(() => {
    initializeSession();
  }, [initializeSession]);

  if (isLoading || !isInitialized) {
    return <LoadingOverlay loaderSize={120} />;
  }

  if (error) {
    console.error('Error initializing session:', error);
    return <SomethingWrong />;
  }

  return <>{children}</>;
};
